import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class IIndexRouteSession {
  id: string | number;
  adet: string;
  @Type(() => Number)
  desi: number;
  pointName: string;
  hidden: number;
  routeid: string | number;
  sessionid: string | number;

  @Type(() => Date)
  createdate: Date;
  lastupdate: Date;
}

export class IIndexRouteSessionResponse {
  @Type(() => IIndexRouteSession)
  result: IIndexRouteSession;
}

export class IIndexRouteSessionListResponse extends IPagination {
  @Type(() => IIndexRouteSession)
  results: IIndexRouteSession[];
}

export class IIndexRouteSessionQueryDto extends IQueryPaginationDto {
  hidden?: number;
  sessionId?: string;
  pointName?: string;
  routeId?: string | number;
  dateCreatedStart?: string;
  dateCreatedEnd?: string;
}
